import { FC } from 'react'
import { LCLoader } from '../lc-loader/LCLoader'

/**
 * Simple loader component for route lazy loading fallback
 * Shows a loading spinner while the route component is being loaded
 */
export const LCRouteLoader: FC = () => {
  return <LCLoader show={true} type="big" />
}
